document.addEventListener('DOMContentLoaded', (event) => {
  /**
   * feedback
   * @description Log the tracking status to the console.
   */
  function feedback() {
    const p = Shopify.customerPrivacy;
    console.log(`Tracking ${p.userCanBeTracked() ? 'en' : 'dis'}abled`);
  }

  /**
   * Shopify.loadFeatures
   * @description Load the Shopify Customer Privacy JavaScript library. With callback.
   */
  Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error) => {
      if (error) throw error;
      // Set or update tracking when CookiebotOnConsentReady event is triggered
      window.addEventListener('CookiebotOnConsentReady', function () {
        handleShopifyTrackingConsent();
        bridgeCookiebotConsent();
      });

      feedback();
      // In case the cookiebot is already accepted
      handleShopifyTrackingConsent();
      bridgeCookiebotConsent();
    }
  );

  /**
   * handleShopifyTrackingConsent
   * @description Set the tracking consent so we can load the Shopify Web Pixel.
   */
  function handleShopifyTrackingConsent() {
    // Check if Cookiebot and customerPrivacy are available
    if (window.Cookiebot?.consented !== undefined && window.Shopify?.customerPrivacy) {
      Shopify.customerPrivacy.setTrackingConsent(Boolean(Cookiebot.consented), feedback);
    }
  }

  /**
   * bridgeCookiebotConsent
   * @description Bridge Cookiebot consent object to Shopify's Web Pixel. So the update can be done.
   */
  function bridgeCookiebotConsent() {
    if (window.Cookiebot?.consent && window.Shopify?.analytics) {
      const event_name = 'cookiebot_on_consent_ready';
      const event_data = {
        ad_personalization: Cookiebot.consent.marketing ? 'granted' : 'denied',
        ad_storage: Cookiebot.consent.marketing ? 'granted' : 'denied',
        ad_user_data: Cookiebot.consent.marketing ? 'granted' : 'denied',
        analytics_storage: Cookiebot.consent.statistics ? 'granted' : 'denied',
        functionality_storage: Cookiebot.consent.preferences ? 'granted' : 'denied',
        personalization_storage: Cookiebot.consent.preferences ? 'granted' : 'denied',
        security_storage: Cookiebot.consent.necessary ? 'granted' : 'denied',
        wait_for_update: 500,
      };
      Shopify.analytics.publish(event_name, event_data);
    }
  }
});
